module.exports = __webpack_public_path__ + "static/miljo1-990b75ecb3309130a974f1cf5410ec3b.jpg";